import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { Station } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

export const data: Mitarbeiter[] = [
  {
    vorname: 'Angelika',
    nachname: 'Müller',
    beruf: new Beruf({
      name: 'Hotelfachfrau',
      abkuerzung: 'HOFA',
      markierung: 'BROWN',
    }),
    lehrjahr: '1. Lehrjahr',
    stationen: [
      new Station({
        id: '123456789_a',
        von: new Date('2026-01-02'),
        bis: new Date('2026-04-24'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Housekeeping',
          markierung: 'YELLOW',
        }),
      }),
      new Station({
        id: '123456789_b',
        von: new Date('2026-04-27'),
        bis: new Date('2026-06-19'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Rezeption',
          markierung: 'BLUE',
        }),
      }),
    ],
  },
  {
    vorname: 'Lisa',
    nachname: 'Fischer',
    lehrjahr: '3. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'KAHO',
      markierung: 'RED',
    }),
    stationen: [
      new Station({
        id: '123456789_c',
        von: new Date('2026-01-05'),
        bis: new Date('2026-02-20'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Rezeption',
          markierung: 'CYAN',
        }),
      }),
      new Station({
        id: '123456789_d',
        von: new Date('2026-02-23'),
        bis: new Date('2026-06-12'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Service',
          markierung: 'GREEN',
        }),
      }),
    ],
  },
  {
    vorname: 'Markus',
    nachname: 'Bachbrunner-Müller',
    lehrjahr: '1. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'HOFA',
      markierung: 'RED',
    }),
    stationen: [
      new Station({
        id: '123456789_e',
        von: new Date('2026-01-12'),
        bis: new Date('2026-01-15'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Rezeption',
          markierung: 'CYAN',
        }),
      }),
      new Station({
        id: '123456789_f',
        von: new Date('2026-01-19'),
        bis: new Date('2026-10-04'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Front Office',
          markierung: 'GOLD',
        }),
      }),
    ],
  },
  {
    vorname: 'Tanja',
    nachname: 'Turner',
    lehrjahr: '2. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'HOFA',
      markierung: 'RED',
    }),
    stationen: [
      new Station({
        id: '123456789_g',
        von: new Date('2026-01-02'),
        bis: new Date('2026-07-19'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Service',
          markierung: 'GREEN',
        }),
      }),
    ],
  },
  {
    vorname: 'Angelika',
    nachname: 'Müller',
    beruf: new Beruf({
      name: 'Hotelfachfrau',
      abkuerzung: 'HOFA',
      markierung: 'BROWN',
    }),
    lehrjahr: '1. Lehrjahr',
    stationen: [
      new Station({
        id: '123456789_h',
        von: new Date('2026-01-02'),
        bis: new Date('2026-04-24'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Housekeeping',
          markierung: 'YELLOW',
        }),
      }),
      new Station({
        id: '123456789_i',
        von: new Date('2026-04-27'),
        bis: new Date('2026-06-19'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Rezeption',
          markierung: 'BLUE',
        }),
      }),
    ],
  },
  {
    vorname: 'Lisa',
    nachname: 'Fischer',
    lehrjahr: '3. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'KAHO',
      markierung: 'RED',
    }),
    stationen: [
      new Station({
        id: '123456789_j',
        von: new Date('2026-01-05'),
        bis: new Date('2026-02-20'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Rezeption',
          markierung: 'CYAN',
        }),
      }),
      new Station({
        id: '123456789_k',
        von: new Date('2026-02-23'),
        bis: new Date('2026-06-12'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Service',
          markierung: 'GREEN',
        }),
      }),
    ],
  },
  {
    vorname: 'Markus',
    nachname: 'Bachbrunner-Müller',
    lehrjahr: '1. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'HOFA',
      markierung: 'RED',
    }),
    stationen: [
      new Station({
        id: '123456789_l',
        von: new Date('2026-01-12'),
        bis: new Date('2026-01-15'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Rezeption',
          markierung: 'CYAN',
        }),
      }),
      new Station({
        id: '123456789_m',
        von: new Date('2026-01-19'),
        bis: new Date('2026-10-04'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Front Office',
          markierung: 'GOLD',
        }),
      }),
    ],
  },
  {
    vorname: 'Tanja',
    nachname: 'Turner',
    lehrjahr: '2. Lehrjahr',
    beruf: new Beruf({
      name: 'Test',
      abkuerzung: 'HOFA',
      markierung: 'RED',
    }),
    stationen: [
      new Station({
        id: '123456789_n',
        von: new Date('2026-01-02'),
        bis: new Date('2026-07-19'),
        arbeitsbereich: new Arbeitsbereich({
          name: 'Service',
          markierung: 'GREEN',
        }),
      }),
    ],
  },
];
